import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AccountListFacadeService } from '@rogers/self-serve-common/account';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AccountSelectorService } from './account-selector.service';

export const selectAccountGuard = (
  _activatedRouteSnapshot: ActivatedRouteSnapshot,
  routerStateSnapshot: RouterStateSnapshot,
  activeAccountsOnly = false,
  excludePrepaidAccounts = false,
): Observable<UrlTree | boolean> => {
  const accountListFacadeService = inject(AccountListFacadeService);
  const accountSelectorService = inject(AccountSelectorService);
  const router = inject(Router);
  return accountListFacadeService.accountListError$.pipe(
    switchMap(error => {
      if (error) {
        return of(false);
      }
      return router.getCurrentNavigation().extras.state?.skipAccountSelectorModal
        ? of(true)
        : accountSelectorService.selectAccount$(
            routerStateSnapshot.url.substring(1),
            activeAccountsOnly,
            excludePrepaidAccounts,
          );
    }),
  );
};
